module.exports = __webpack_public_path__ + "img/002吴向军.0658282e.png";